export function TablePlusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 4a3 3 0 00-3 3v10a3 3 0 003 3h6.528A5.985 5.985 0 0016 22a5.997 5.997 0 005.131-2.889A2.99 2.99 0 0022 17V7a3 3 0 00-3-3H5zm14.318 7H20V7a1 1 0 00-1-1h-6v4.803A5.972 5.972 0 0116 10c1.227 0 2.367.368 3.318 1zm-8.515 2H4v4a1 1 0 001 1h5.341A5.99 5.99 0 0110 16c0-1.093.292-2.117.803-3zM17 19v-2h2a1 1 0 100-2h-2v-2a1 1 0 10-2 0v2h-2a1 1 0 100 2h2v2a1 1 0 102 0zm-6-8H4V7a1 1 0 011-1h6v5z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
